import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/icons/open.svg';
import _imports_1 from '@/assets/images/icons/farm.png';
import _imports_2 from '@/assets/images/icons/unauthorized_operator.png';
const _hoisted_1 = {
  class: "section-padding pt-0 horizontal-accordion bg-light-gray mt-4"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "26px",
    "margin-bottom": "4px",
    "color": "white",
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "28px",
    "height": "28px"
  },
  class: "mr-2",
  alt: ""
}, null, -1);
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  class: "fw-medium fsi-16 mr-2",
  style: {
    "color": "#3d3d3d"
  }
};
const _hoisted_8 = {
  class: "fw-bold fsi-16"
};
const _hoisted_9 = {
  class: "mt-3"
};
const _hoisted_10 = {
  class: "row mt-2"
};
const _hoisted_11 = {
  class: "col-xl-7 col-12 order-xl-1 order-2 mt-xl-0 mt-4"
};
const _hoisted_12 = {
  class: "col-xl-5 col-12 order-xl-2 order-1"
};
const _hoisted_13 = {
  class: "row",
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_14 = {
  class: "col-lg-9 col-12"
};
const _hoisted_15 = {
  class: "row",
  style: {
    "color": "#101B52"
  }
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "width": "60%"
  },
  alt: ""
})])], -1);
const _hoisted_17 = {
  class: "col-12"
};
const _hoisted_18 = {
  class: "fw-bold fsi-18 text-center"
};
const _hoisted_19 = {
  class: "col-12 mt-2"
};
const _hoisted_20 = {
  class: "text-center fw-medium fsi-14"
};
const _hoisted_21 = {
  class: "col-12 mt-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_page_head = _resolveComponent("page-head");
  const _component_LeftBox = _resolveComponent("LeftBox");
  const _component_RightBorrow = _resolveComponent("RightBorrow");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_MinerOverview = _resolveComponent("MinerOverview");
  const _component_History = _resolveComponent("History");
  const _component_VaultInfo = _resolveComponent("VaultInfo");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_page_head, {
    showReturn: true,
    backPath: "/farm"
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.Node')) + " f0" + _toDisplayString($data.nodeId) + " ", 1), _createElementVNode("span", {
      style: {
        "margin-left": "5px"
      },
      onClick: _cache[0] || (_cache[0] = (...args) => $options.openNode && $options.openNode(...args))
    }, _hoisted_4)]),
    icon: _withCtx(() => [_hoisted_5]),
    "title-right-tool": _withCtx(() => [$options.filPrice !== '0.00' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('common.CurrentFILPrice')), 1), _createElementVNode("span", _hoisted_8, "$" + _toDisplayString($options.filPrice), 1)])) : _createCommentVNode("", true)]),
    _: 1
  }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_tabs, {
    modelValue: $options.activeName,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.activeName = $event),
    class: "demo-tabs",
    onTabChange: $options.handleClick
  }, {
    default: _withCtx(() => [$data.is_active ? (_openBlock(), _createBlock(_component_el_tab_pane, {
      key: 0,
      label: _ctx.$t('farm.console.Overview'),
      lazy: true,
      name: "first"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_LeftBox, {
        nodeId: $data.nodeId
      }, null, 8, ["nodeId"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_RightBorrow, {
        "node-id": $data.nodeId,
        onUpdateInfo: $options.init,
        onApproveOperator: $options.showApproveOperatorDialog
      }, null, 8, ["node-id", "onUpdateInfo", "onApproveOperator"])])])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_tab_pane, {
      label: _ctx.$t('farm.console.Miner Overview'),
      name: "four",
      lazy: true
    }, {
      default: _withCtx(() => [_createVNode(_component_MinerOverview, {
        ref: "minerOverview",
        "node-id": $data.nodeId
      }, null, 8, ["node-id"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_tab_pane, {
      label: _ctx.$t('farm.console.History'),
      name: "third",
      lazy: true
    }, {
      default: _withCtx(() => [_createVNode(_component_History, {
        ref: "history",
        "node-id": $data.nodeId
      }, null, 8, ["node-id"])]),
      _: 1
    }, 8, ["label"]), $data.is_active ? (_openBlock(), _createBlock(_component_el_tab_pane, {
      key: 1,
      label: _ctx.$t('farm.console.Settings'),
      name: "second",
      lazy: true
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_VaultInfo, {
        "node-id": $data.nodeId
      }, null, 8, ["node-id"])])])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "onTabChange"])]), _createVNode(_component_el_dialog, {
    modelValue: $data.showNoOperatorDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.showNoOperatorDialog = $event),
    width: "445px",
    top: "10%",
    "before-close": $options.closeNoOperatorDialog
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('farm.console.Oopsunauthorized operator')), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('farm.console.Oopsunauthorized operator2')), 1)]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_button, {
      class: "btn btn-primary w-100 i-button",
      type: "primary",
      onClick: $options.approveOperator
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.ApproveOperator')), 1)]),
      _: 1
    }, 8, ["onClick"])])])]),
    _: 1
  }, 8, ["modelValue", "before-close"])])]);
}